import React from 'react';

export interface CheckedIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CheckedIcon = ({ width = 12, height = 12, color = 'white' }: CheckedIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 6L5 8.5L10 3.5" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CheckedIcon;
